import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useTRPC } from 'utils/trpc'
import { useAiHelp } from './AiHelpProvider'

export function useAiHelpRestore() {
    const trpc = useTRPC()
    const { messages, setConversationId, hydrateMessages } = useAiHelp()

    const { data } = useQuery({
        ...trpc.aiHelp.getLatestConversation.queryOptions(),
        enabled: messages.length === 0,
        staleTime: Infinity,
    })

    useEffect(() => {
        if (data && messages.length === 0) {
            setConversationId(data.conversationId)
            hydrateMessages(data.messages.map(m => ({ role: m.role, content: m.content })))
        }
    }, [data])
}
